import expenseTrackerImg from "../src/assets/projectPics/expenseTracker.jpg";
import portfolioImg from "../src/assets/projectPics/portfolio.jpg";
import defaultImg from "../src/assets/projectPics/projectPic.webp";

export const contactLinks = [
  {
    name: "LinkedIn",
    logo: require("../src/assets/icons/linkedin.svg").default,
    link: "https://www.linkedin.com/in/vips-kumar/",
  },
  {
    name: "Github",
    logo: require("../src/assets/icons/github.svg").default,
    link: "https://github.com/vipulkumar4321",
  },
  {
    name: "Twitter",
    logo: require("../src/assets/icons/twitter.svg").default,
    link: "https://twitter.com/VipulKumar4321",
  },
  {
    name: "Stack Overflow",
    logo: require("../src/assets/icons/stackoverflow.svg").default,
    link: "https://stackoverflow.com/users/10858298/vipul-kumar",
  },
  {
    name: "Leetcode",
    logo: require("../src/assets/icons/leetcode.svg").default,
    link: "https://leetcode.com/vipulkumar4321/",
  },
  {
    name: "GeekForGeeks",
    logo: require("../src/assets/icons/gfg.svg").default,
    link: "https://auth.geeksforgeeks.org/user/vips_infinity",
  },
  {
    name: "Instagram",
    logo: require("../src/assets/icons/instagram.svg").default,
    link: "https://www.instagram.com/vips_infinity",
  },
  {
    name: "WhatsApp",
    logo: require("../src/assets/icons/whatsapp.svg").default,
    link: "https://api.whatsapp.com/send?phone=918765263553",
  },
  {
    name: "Mail",
    logo: require("../src/assets/icons/mail.svg").default,
    link: "mailto:vipulkumar4321@gmail.com",
  },
];

export const projects = [
  {
    title: "Portfolio Website",
    tech: [
      "React",
      "HTML",
      "CSS",
      "JavaScript",
      "Tailwind",
      "Git/Github",
      "...",
    ],
    content: [
      "Developed a personal website showcasing portfolio, skills, and projects using React.js and Tailwind CSS",
      "Employed modern design principles and responsive layouts for seamless user interaction across devices.",
    ],
    link: "https://github.com/vipulkumar4321/portfolio",
    live: "https://mrvipulkumar.com",
    img: portfolioImg,
  },
  {
    title: "Expense Tracker",
    tech: ["React", "HTML", "CSS", "JavaScript", "AWS"],
    content: [
      "Crafted a simple yet effective static website using React and deployed it on AWS to track yearly expenses.",
      "Demonstrated proficiency in React development and deployment on cloud infrastructure.",
    ],
    link: "https://github.com/vipulkumar4321/React-Expense-Tracker",
    live: "https://project-expense-tracker.mrvipulkumar.com",
    img: expenseTrackerImg,
  },
  {
    title: "Bird Species Recognition System",
    tech: ["React", "Flask", "AWS", "Gunicorn", "Deep Learning"],
    content: [
      "Identify bird species from provided images with an accuracy rate of 98%.",
      "Integrated an inbuilt Wikipedia scraper to provide additional information about recognized bird species.",
    ],
    link: "https://github.com/vipulkumar4321/BIrdFinder/tree/Vipul",
    img: defaultImg,
  },
  // {
  //   title: "Web-to-Mobile",
  //   tech: ["Node.js", "Express", "AWS"],
  //   content: [
  //     "Enable users to send messages from websites to designated mobile numbers.",
  //     "Showcased versatility in developing cross-platform communication solutions.",
  //   ],
  //   link: "https://github.com/vipulkumar4321?tab=repositories",
  //   img: defaultImg,
  // },
  // {
  //   title: "Blog",
  //   tech: ["Node.js", "Express", "JavaScript", "MongoDB", "Semantic UI", "AWS"],
  //   content: [
  //     "Designed and developed a fully customizable cross-platform blog website from scratch",
  //     "Demonstrated expertise in front-end and back-end development and deployment on cloud platforms.",
  //   ],
  //   link: "https://github.com/vipulkumar4321?tab=repositories",
  //   img: defaultImg,
  // },
  {
    title: "OCR Model",
    tech: ["Node.js", "Express", "AWS"],
    content: [
      "Built an OCR model using Node.js, Express, HTML, and CSS to accurately extract text from images.",
      "Ensured accessibility and ease-of-use by allowing users to effortlessly process images and retrieve extracted text directly from the browser.",
    ],
    link: "https://github.com/vipulkumar4321/OCRmodel",
    img: defaultImg,
  },
];

export const skills = [
  {
    name: "Languages",
    data: [
      { skill: "Java", logo: require("../src/assets/icons/java.svg").default },
      {
        skill: "JavaScript",
        logo: require("../src/assets/icons/javascript.svg").default,
      },
      {
        skill: "TypeScript",
        logo: require("../src/assets/icons/typescript.svg").default,
      },
      {
        skill: "Python",
        logo: require("../src/assets/icons/python.svg").default,
      },
    ],
  },
  {
    name: "Front-End",
    data: [
      { skill: "HTML", logo: require("../src/assets/icons/html.svg").default },
      { skill: "CSS", logo: require("../src/assets/icons/css.svg").default },
      {
        skill: "React",
        logo: require("../src/assets/icons/react.svg").default,
      },
      {
        skill: "Material UI",
        logo: require("../src/assets/icons/material_ui.svg").default,
      },
      {
        skill: "Tailwind",
        logo: require("../src/assets/icons/tailwind.svg").default,
      },
      {
        skill: "Bootstrap",
        logo: require("../src/assets/icons/bootstrap.svg").default,
      },
    ],
  },
  {
    name: "Back-End",
    data: [
      {
        skill: "Node JS",
        logo: require("../src/assets/icons/node_js.svg").default,
      },
      {
        skill: "Express",
        logo: require("../src/assets/icons/express.svg").default,
      },
      {
        skill: "Flask",
        logo: require("../src/assets/icons/flask.svg").default,
      },
    ],
  },
  {
    name: "Database",
    data: [
      {
        skill: "MySQL",
        logo: require("../src/assets/icons/mysql.svg").default,
      },
      {
        skill: "MongoDB",
        logo: require("../src/assets/icons/mongodb.svg").default,
      },
    ],
  },
  {
    name: "DevOps",
    data: [
      {
        skill: "Docker",
        logo: require("../src/assets/icons/docker.svg").default,
      },
      {
        skill: "Nginx",
        logo: require("../src/assets/icons/nginx.svg").default,
      },
      {
        skill: "Gunicorn",
        logo: require("../src/assets/icons/gunicorn.svg").default,
      },
      {
        skill: "Git/Github",
        logo: require("../src/assets/icons/git.svg").default,
      },
    ],
  },
  {
    name: "Cloud",
    data: [
      { skill: "AWS", logo: require("../src/assets/icons/aws.svg").default },
      {
        skill: "Azure",
        logo: require("../src/assets/icons/azure.svg").default,
      },
    ],
  },
  {
    name: "Technologies",
    data: [
      {
        skill: "Backstage.io",
        logo: require("../src/assets/icons/backstage.svg").default,
      },
      {
        skill: "Blockchain",
        logo: require("../src/assets/icons/blockchain.svg").default,
      },
    ],
  },
];
